import $ from 'jquery'

export default {
    name: 'delete-modal',
    components: {},
    props: {
        patient_id: Number,
        operations: Array,
        proforma_id: Number
    },
    data() {
        return {
            del_loading: false,
            is_confirm: false,
            error_message: ''
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
         /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimer(selector) {
            this.error_message = ''
            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { 
                $('.err-msg').fadeIn(500)
                this.del_loading = false
                return
            }
            let data = {
                patient_id: this.patient_id,
                operations: this.operations,
            }

            this.del_loading = true;
            this.$store.dispatch('deleteVentePrestation', data).then((response) => {
                if (response.success) {
                    this.successToast("Opération(s) supprimée(s) avec succès")
                    this.$emit('emitPrestation', this.proforma_id)

                    this.is_confirm = false
                    this.$refs.confimation.click();
                } else {
                    if (response.code == 401) {         // Permission denied
                        this.error_message = "Impossible de supprimer"
                    } else if (response.code == 409) {
                        this.error_message = "Impossible de supprimer"
                    } else if (response.code == 500) {
                        this.error_message = "Une erreur s'est produite !"
                    }
                }
                this.del_loading = false
            }).catch(() => {
                this.del_loading = false
                this.error_message = "Une erreur s'est produite !"
            })
        },
    }
}